import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=da78c3c4&scoped=true&"
import script from "./InfoDialog.vue?vue&type=script&lang=js&"
export * from "./InfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./InfoDialog.vue?vue&type=style&index=0&id=da78c3c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da78c3c4",
  null
  
)

export default component.exports